import { createFileRoute, notFound } from '@tanstack/react-router';

import { buildGuards, hasFlagEnabled } from '@mint-lib/routing-guards';
import { Metadata } from '@mint-sdk/api-mdm';

const guard = buildGuards(hasFlagEnabled('settingsMint2'));

const suggestionEmailsPageGuard = buildGuards(
  hasFlagEnabled('suggestionEmailsPage'),
);

export const Route = createFileRoute(
  '/_secured/external-data/integrations/$integration/suggestion-emails',
)({
  beforeLoad: async ({ context }) => {
    const guardsContext = await context.getGuardContext(
      await context.getInstance('flagsmith', '@mint/arm'),
    );
    if (!guard(guardsContext) || !suggestionEmailsPageGuard(guardsContext)) {
      throw notFound();
    }
  },
  loader: async ({ context, params }) => {
    const i18n = await context.getInstance('i18n', '@mint/routing');
    const [, profile] = await context.serviceLocator.getInstance('profile');
    const companyId = profile?.getProfileData()?.profile.company.id;

    const platformsMint2 = await context
      .prefetchQuery(
        Metadata.getContextMetadataQueryOptions({
          params: {
            fieldUrnIds: ['platform_v2'],
            companyId,
            context: 'integration',
          },
        }),
      )
      .catch(() => undefined);

    const platformLabel =
      platformsMint2?.[
        Object.keys(platformsMint2).find((key) =>
          key.includes('platform_v2'),
        ) ?? ''
      ]?.options.find((option) => option.value.includes(params.integration))
        ?.label ?? '';

    const title = i18n.t('Suggestion Emails - {{platform}} | MINT', {
      platform: platformLabel || params.integration,
    });

    return { title };
  },
  head: ({ loaderData }) => ({
    meta: [
      {
        title: loaderData?.title,
      },
    ],
  }),
});
